module.exports = __webpack_public_path__ + "e0d38ee538efb4c764e64ac9a29adc12.pdf";